import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { apiShootGetRequest, resetShoot } from '../../Redux/actions/shoot';
import { apiGetAllShootRobotsRequest, apiGetAllShootInstanceRequest } from '../../Redux/actions/gear';

import DashboardLayout from '../../Layouts/DashboardLayout';
import Main from './Main';
import Loader from 'Components/Loader';

import tutorialLaunchpadBg from '../../Assets/images/tutorialLaunchpadBg.png';

const LaunchpadPage = () => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const shootState = useSelector(state => state.shoot);
  const gear = useSelector(state => state.gear);
  const { project_id } = useParams();

  useEffect(() => {
    dispatch(resetShoot());
  }, []);

  useEffect(() => {
    dispatch(apiShootGetRequest(auth.token, project_id));
    dispatch(apiGetAllShootRobotsRequest(auth.token, project_id));
    dispatch(apiGetAllShootInstanceRequest(auth.token, project_id));
  }, [project_id]);

  return (
    <DashboardLayout>
      {
        project_id === '0'
        ? ( <img src={tutorialLaunchpadBg} className='img-fluid mt-4'/> )
        : (
          shootState.isLoading || !shootState.shoot || gear.isLoading
          ? <Loader />
          : <Main state={shootState} project_id={project_id} />
        )
      }
    </DashboardLayout>
  );
};

export default LaunchpadPage;
